"use client";
import { Box, Button, Paper, Stack, Text, Title } from "@mantine/core";
import WestRounded from "@mui/icons-material/WestRounded";
import clsx from "clsx";
import { useRouter } from "next/navigation";
import ErrorBanner from "../../public/static/images/permissions/erroricon.svg";
import { useAccessBannerStyles } from "../components/access/NoAccess";

export default function Error() {
  const router = useRouter();
  const { classes } = useAccessBannerStyles();
  return (
    <Paper
      style={{
        isolation: "isolate",
        alignContent: "center",
        background: "light-dark(white, var(--mantine-color-dark-9))",
      }}
      radius={0}
      h={"100vh"}
      display="grid"
    >
      <Stack className={classes.wrapper}>
        <Title
          order={1}
          className={classes.title}
          mb={"-2rem"}
          style={{
            backgroundImage:
              "linear-gradient(180deg, var(--mantine-color-incorrect-4), var(--mantine-color-incorrect-6))",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
            color: "transparent",
          }}
        >
          Something&apos;s Not Right
        </Title>
        <Box className={classes.imgWrapper} mx={"auto"}>
          <ErrorBanner />
        </Box>
        <Text className={classes.text}>
          Your browser couldn&apos;t handle that code.
        </Text>
        <Text className={classes.text}>
          Please{" "}
          <span className={classes.highlight}>try again now (or later)</span>.
          Everything should be back in action!
        </Text>
        <Text className={classes.text}>
          If you are still seeing this message and its been a while,{" "}
          <span className={clsx(classes.highlight, classes.highlight2)}>
            contact us
          </span>{" "}
          using the form at the bottom of our site.
        </Text>
        <Button
          name="Back"
          className={classes.button}
          color="incorrect"
          size="lg"
          onClick={() => router.back()}
          leftSection={<WestRounded />}
        >
          Go Back
        </Button>
      </Stack>
    </Paper>
  );
}
